import {
  Badge,
  Button,
  Card,
  Group,
  SimpleGrid,
  Stack,
  Text,
  Title,
  TitleContainer,
} from "@dutyon/ui-kit";
import { ArrowRight, ExternalLink } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { analyticsReports, miniExplorationUrl } from "./reports";

export function AnalyticsReportLinks() {
  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Title order={3}>Mini 이용 분석 · Google Analytics</Title>
        <Badge variant="light">운영 데이터</Badge>
      </Group>
      <Text size="sm" c="dimmed">
        보고서별로 볼 수 있는 정보와 읽는 방법을 확인한 뒤 GA를 여세요. GA 속성에 접근 권한이 있는
        Google 계정이 필요합니다.
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2, lg: 3 }}>
        {analyticsReports.map((report) => (
          <Card key={report.slug} withBorder radius="md" padding="lg">
            <Stack gap="sm" h="100%">
              <Title order={4}>{report.title}</Title>
              <Text size="sm" c="dimmed" style={{ flex: 1 }}>
                {report.description}
              </Text>
              <Button
                component={Link}
                to={`/analytics/${report.slug}`}
                variant="light"
                rightSection={<ArrowRight size={16} />}
              >
                {report.title} 안내
              </Button>
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}

export function AnalyticsReportPage() {
  const { reportSlug } = useParams();
  const report = analyticsReports.find((item) => item.slug === reportSlug);
  if (!report) {
    return (
      <TitleContainer title="보고서를 찾을 수 없습니다">
        <Button component={Link} to="/home?tab=mini">
          대시보드로 돌아가기
        </Button>
      </TitleContainer>
    );
  }
  return (
    <TitleContainer title={report.title} description={report.description}>
      <Stack gap="lg" maw={960}>
        <Button
          component={Link}
          to="/home?tab=mini"
          variant="subtle"
          style={{ alignSelf: "flex-start" }}
        >
          대시보드로 돌아가기
        </Button>
        <Card withBorder radius="md" padding="lg">
          <Stack>
            <Badge style={{ alignSelf: "flex-start" }}>DutyOn Mini 운영 · GA4</Badge>
            <Title order={3}>어떤 정보를 볼 수 있나요?</Title>
            <Text>{report.metrics}</Text>
            <Title order={3}>어떻게 읽으면 되나요?</Title>
            <Text>{report.reading}</Text>
            <Title order={3}>해석할 때 확인하세요</Title>
            <Text>{report.limitation}</Text>
          </Stack>
        </Card>
        <Card withBorder radius="md" padding="lg">
          <Stack>
            <Title order={3}>GA에서 확인하는 순서</Title>
            <Text>
              1. 아래 버튼으로 저장된 「Mini 운영 분석 · 여정과 기능 활용」 탐색을 엽니다.
            </Text>
            <Text>
              2. 탐색 안에서 「{report.tab}」 탭을 선택합니다. 모든 안내 페이지는 같은 탐색으로
              연결됩니다.
            </Text>
            <Text>
              3. 조회 기간을 선택하고 Mini 운영 필터(service=mini, environment=production)를
              확인합니다. 기간과 기기 조건을 맞춰 비교하세요.
            </Text>
            <Button
              component="a"
              href={miniExplorationUrl}
              target="_blank"
              rel="noopener noreferrer"
              rightSection={<ExternalLink size={16} />}
              style={{ alignSelf: "flex-start" }}
            >
              GA 탐색 열기 (새 탭)
            </Button>
            <Text size="sm" c="dimmed">
              접근이 거부되면 운영 GA 속성의 보기 권한을 요청하세요. 동의한 사용자만 집계되며 추적
              차단과 집계 지연으로 데이터가 누락되거나 비어 있을 수 있습니다. GA 수치는 전체 업무
              실적이 아닙니다.
            </Text>
            <Button
              component={Link}
              to="/statistics/duty-generation"
              variant="light"
              style={{ alignSelf: "flex-start" }}
            >
              내부 Duty 자동 생성 통계 보기
            </Button>
          </Stack>
        </Card>
        <AnalyticsReportLinks />
      </Stack>
    </TitleContainer>
  );
}
